export const communityConstants = {
  WALLPOSTS_BY_PAGE: 10, //It should match with v1/wall API view on Backend.
  MEETUPS_BY_PAGE: 10, //It should match with v1/meetups API view on Backend.
  COMMENTS_BY_PAGE: 5, //It should match with v1/comments API view on Backend.
};
